/**
 * The two goal enums the route's search schema needs, in a module that imports
 * nothing.
 *
 * Same bundle decision as `offer-vocabulary.ts`, and for the same reason:
 * `router.tsx` imports every route's `validateSearch` schema EAGERLY, because a
 * search schema has to exist at route-definition time, before the route
 * component is ever loaded. `goals.route.search.ts` used to reach for
 * `goalStatusSchema` and `goalScopeSchema` through `goals/schemas/goal.schema`,
 * which is a `export *` barrel over seven schema files. That one eager edge put
 * every goal wire, mutation, query, read, risk and task schema into the initial
 * chunk of an app most of whose users open the goals page later, or never.
 *
 * The tuples are the single source of truth: `goal-base.schema.ts` builds the
 * Zod enums from them, so the vocabulary cannot drift between the URL parser
 * and the wire parser.
 */

/// Mirror of the shore's goal scope vocabulary.
export const GOAL_SCOPES = ["individual", "department", "workspace"] as const;
export type GoalScopeName = (typeof GOAL_SCOPES)[number];

/// Mirror of the shore's goal status vocabulary, in its order.
export const GOAL_STATUSES = ["draft", "active", "paused", "completed", "cancelled"] as const;
export type GoalStatusName = (typeof GOAL_STATUSES)[number];
